import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import template from './argument-truncator.hbs'
import i18n from 'scoreboard/components/i18n'

var ArgumentTruncator = Backbone.View.extend({

	className: 'argument-truncator',

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		var key = this.options.key || {}
		var substitution = this.options.substitution || {}
		var string = i18n.get(key, substitution)

		// Need to get the index of the very last character of the wrapped text.
		var endIndex = string.indexOf(substitution) + substitution.length

		// If no text comes after the substitution or there is no substitution, we will truncate it at the
		// end like any other string and can avoid spliting the string and checking for widths, etc...
		if (endIndex === string.length || string.indexOf(substitution) < 0) {
			this.$el.empty().append(string)
		} else {
			// If there IS text after the substitution, we want to make sure that text is always visible and truncate the label before it instead.
			this.$el.empty().append(template({
				firstHalf: string.substr(0, endIndex),
				lastHalf:  string.substring(endIndex)
			}))

			// Cache so these don't get constantly looked up on a browser resize.
			this.firstHalf = this.$('.first-half')
			this.lastHalf = this.$('.last-half')

			process.nextTick(function() {
				this.container = this.$el.parent()
				this.setWidths()
			}.bind(this))

			$(window).resize(function() {
				this.setWidths()
			}.bind(this))
		}

		return this
	},

	setWidths: function() {
		var width = this.firstHalf.width() + this.lastHalf.width() + 2 // 2 extra pixels to prevent accidental truncating
		this.$el.width(_.min([width, this.container.width() - 20])) // 20 is for the standard padding
		//Edge can only get the correct width of the text if these properties are applied after.
		this.$('.text').css({
			'overflow': 'hidden',
			'text-overflow': 'ellipsis'
		})
	}

})

export default ArgumentTruncator


ArgumentTruncator.__filename__ = 'components/argument-truncator.js'
